// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailC":"C_dpuDetailC__17XmD"};